// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__6yQZN","approved":"Status_approved__suCAB","rejected":"Status_rejected__1tDod","expired":"Status_expired__jyznO","label":"Status_label__i3Wku"};